<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Internal User</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Internal User</b>
      <b-row>
        <b-col>
          <b-card class="text-center bg-gray-100">
            <b-row>
              <b-col>
                <img v-show="!file" v-if="items.image" width="100%" :src="items.image" />
                <img v-show="file" v-if="url" width="100%" :src="url" />
              </b-col>
            </b-row>
            <input type="file" ref="file" style="display: none" @change="onChangeFileUpload()" />
            <br />
            <b-link
              @click="$refs.file.click()"
              v-show="!file && !items.image"
              variant="primary"
              class="text-primary btn"
            >
              <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
              <label class="text-danger">*</label>
            </b-link>
            <b-button
              @click="$refs.file.click()"
              v-show="file || items.image"
              variant="outline-primary"
              class
            >
              <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
            </b-button>
            <br />
            <div
              v-show="InputImage"
              class="text-danger"
              id="input-answer_en-feedback"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >
              <label v-if="widthImage != 500 || heightImage != 500">Image dimension not correct</label>
              <label v-if="file.size >= 2000000">&nbsp;Image size maximum 2 Mb</label>
            </div>
            <p
              class="text-gray-500"
            >Attach an image (the file must be at least 500x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
          </b-card>
        </b-col>
        <b-col md="8">
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="NIM"
                label-for="input-1"
              >
                <input
                  v-model="items.nim"
                  v-validate="'required|numeric'"
                  name="nim"
                  class="form-control"
                  placeholder="Enter a NIM"
                />
                <b-form-invalid-feedback id="input-nim-feedback">{{ veeErrors.first('nim') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Username"
                label-for="input-1"
              >
                <input
                  v-model="items.username"
                  v-validate="'required|alpha_num'"
                  name="username"
                  class="form-control"
                  placeholder="Enter a Username"
                />
                <b-form-invalid-feedback
                  id="input-username-feedback"
                >{{ veeErrors.first('username') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Full Name"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.fullname"
                  name="full_name"
                  id="input-1"
                  class="form-control"
                  placeholder="Full Name"
                />
                <b-form-invalid-feedback
                  id="input-full_name-feedback"
                >{{ veeErrors.first('full_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Email"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.email"
                  name="email"
                  id="input-1"
                  class="form-control"
                  placeholder="Email"
                />
                <b-form-invalid-feedback id="input-email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Role"
                label-for="input-1"
              >
                <select
                  class="custom-select"
                  v-validate="'required'"
                  name="role"
                  v-model="items.role"
                  required
                  :disabled="this.$route.params.redirect == 'profile'"
                >
                  <option value>Select Role</option>
                  <option v-for="role in roles" :key="role" :value="role.RoleCode">{{role.RoleName}}</option>
                </select>
                <b-form-invalid-feedback id="input-role-feedback">{{ veeErrors.first('role') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Phone Number"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <input
                  v-validate="'required|numeric'"
                  v-model="items.phone_number"
                  name="phone_number"
                  class="form-control"
                  placeholder="Phone Number"
                />
                <b-form-invalid-feedback
                  id="input-phone_number-feedback"
                >{{ veeErrors.first('phone_number') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label="Address"
                class="required"
                label-class="control-label"
                label-for="input-1"
              >
                <textarea
                  @input="isHiddenAddress = true"
                  tag-name="textarea"
                  placeholder="Address"
                  v-model="items.address"
                  class="form-control"
                ></textarea>
                <div
                  v-show="isHiddenAddress"
                  class="text-danger"
                  id="input-address-feedback"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >
                  <p v-if="items.address.length === 0">The Adress field is required</p>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <div class="form-group required font-weight-bold">
            <label class="control-label"></label>
            Required
          </div>
          <b-row class="text-right">
            <b-col>
              <b-button
                variant="primary"
                :disabled="veeErrors.any() || !isCompleted || loading"
                @click="put()"
                class="mr-3"
                size="lg"
              >
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: this.$route.params.redirect}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: '',
      InputImage: false,
      widthImage: null,
      heightImage: null,
      url: '',
      loading: false,
      nim: '',
      username: '',
      password: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      address: '',
      items: [],
      roles: [],
      isHiddenAddress: false,
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      'internalUserModule/getInternalUser',
      this.$route.params.id,
    );
    this.$store.dispatch('internalUserModule/getRole', { root: true });
  },
  created() {
    this.$store.watch(
      state => state.internalUserModule.internal_user_id,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
    this.$store.watch(
      state => state.internalUserModule.role,
      (newValue, oldValue) => {
        this.roles = newValue;
      },
    );
  },
  methods: {
    put() {
      this.loading = true;
      const formData = new FormData();
      formData.append('image', this.file);
      formData.append('nim', this.items.nim);
      formData.append('username', this.items.username);
      formData.append('fullname', this.items.fullname);
      formData.append('role', this.items.role);
      formData.append('phone_number', this.items.phone_number);
      formData.append('email', this.items.email);
      formData.append('address', this.items.address);
      this.$store
        .dispatch('internalUserModule/putInternalUser', {
          id: this.$route.params.id,
          formData,
        })
        .then((response) => {
          this.loading = false;
          this.$store.dispatch(
            'internalUserModule/getInternalUserHeader',
            this.$session.get('jwt').id,
          );
          this.$router.push({ name: this.$route.params.redirect });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      this.InputImage = true;
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
  computed: {
    isCompleted() {
      if (this.file) {
        return (
          this.items.nim
          && this.items.username
          && this.items.role
          && this.items.fullname
          && this.items.email
          && this.items.phone_number
          && this.items.address
          && this.file.size <= 2000000
          && this.widthImage == 500
          && this.heightImage == 500
        );
      }
      return (
        this.items.nim
          && this.items.username
          && this.items.role
          && this.items.fullname
          && this.items.email
          && this.items.phone_number
          && this.items.address
      );
    },
  },
};
</script>

<style>
</style>
